require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-would-you-netflix-your-next-car.json") })
        }
      }, "path---news-would-you-netflix-your-next-car");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-would-you-netflix-your-next-car!./.cache/json/news-would-you-netflix-your-next-car.json
// module id = 1442
// module chunks = 231608221292675